import React from 'react';
import { array, bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import { get } from 'lodash';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

import classes from './CreateEntityModal.module.css';

const ValidationSchema = Yup.object().shape({
    clientName: Yup.string()
        .required(),
    campusName: Yup.string()
        .required()
});

const CreateCampusModal = ({
    close,
    clearErrors,
    clientNodes,
    companyInfo,
    errors,
    isLoading,
    open,
    selectedClient,
    title,
    toggleLoading,
    ...props
}) => {

    const formik = useFormik({
        initialValues: {
            clientName: get(selectedClient, 'id', ''),
            campusName: ''
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                createCampus
            } = props;

            let isCreated;

            const clientId = values.clientName;

            const body = {
                name: values.campusName
            };

            clearErrors();
            setSubmitting(true);

            try {
                if (!isLoading) {
                    toggleLoading(true);
                    isCreated = await createCampus(companyInfo, clientId, body);
                }

                if (isCreated) {
                    setSubmitting(false);
                    toggleLoading(false);

                    handleClose();
                } else {
                    setSubmitting(false);
                    toggleLoading(false);
                }
            } catch (error) {
                setSubmitting(false);
            }
        }
    });


    const handleClose = () => {
        toggleLoading(false);
        clearErrors();

        close();
    };

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={handleClose}
            title={title}
            onRendered={formik.handleReset}
            onConfirm={formik.handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
            confirmText="Create"
        >
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/campusTreeIcon.svg" alt="new campus icon" />
                        <span>New Campus</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>
                            Select a Client to associate this Campus.
                        </p>
                        <p>
                            Enter a Campus name.
                        </p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={`${classes.inputWrapper}`}>
                            <InputLabel
                                htmlFor="clientName"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                                error={Boolean(formik.errors.clientName) && Boolean(formik.touched.clientName)}
                            >
                                Client Name
                            </InputLabel>
                            <Select
                                value={formik.values.clientName}
                                onChange={formik.handleChange}
                                className={classes.select}
                                inputProps={{
                                    name:   'clientName',
                                    id:     'clientName',
                                    onBlur: formik.handleBlur
                                }}
                                error={Boolean(formik.errors.clientName) && Boolean(formik.touched.clientName)}
                            >
                                {
                                    clientNodes.map(type =>
                                        <MenuItem
                                            key={type.id}
                                            value={type.id}
                                        >
                                            {type.name}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                            {formik.touched.clientName &&
                                formik.errors.clientName && <FormHelperText className={classes.error}>{formik.errors.clientName}</FormHelperText>}
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="campusName"
                                name="campusName"
                                type="text"
                                value={formik.values.campusName}
                                label="Name"
                                onChange={formik.handleChange}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.campusName) && Boolean(formik.touched.campusName)}
                                helperText={Boolean(formik.touched.campusName) && formik.errors.campusName}
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
        </EsmsDialog >
    );
};


CreateCampusModal.defaultProps = {
    clientNodes: []
};

CreateCampusModal.propTypes = {
    clientNodes: array,
    close:       func.isRequired,
    open:        bool.isRequired,
    title:       string.isRequired
};

const mapStateToProps = state => {
    return {
        clientNodes:    state.architect.clientNodes,
        companyInfo:    state.companyInfo,
        errors:         state.messages.errors,
        isLoading:      state.ui.isLoading,
        selectedClient: state.client.selectedClient
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCampusModal);
